import React from "react";
import { Navigate } from "react-router-dom";

import ListaCondicaoPagamento from "../pages/CadastrosPadrao/CondicaoPagamento";
import ListaFormaPagamento from "../pages/CadastrosPadrao/FormaPagamento";
import ListaTipoEspaco from "../pages/CadastrosPadrao/TipoEspaco";
import ListaTags from "../pages/CadastrosPadrao/Tags";
import ListaStatusReserva from "../pages/CadastrosPadrao/StatusReserva";
import ListaFeira from "../pages/Feiras/Lista";
import CadastroFeira from "../pages/Feiras/Cadastro";
import CadastroExpositor from "../pages/Expositores/Cadastro";
import ImportExpositoresModal from "../pages/Expositores/Importacao";
import ListaUsuarios from "../pages/Usuarios";
import ListaReservas from "../pages/Reservas/Lista";
import ReservaDetalhes from "../pages/Reservas/Detalhes";
import NaoEncontrada from "../pages/NaoEncontrada";
import MapaDesativado from "../pages/MapaDesativado";
import ListaEspera from "../pages/ListaEspera";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import ListaExpositor from "../pages/Expositores/Lista";
import PaginaMapaIndependente from "../Layouts/indexMapas";
import MapaComRota from "../Layouts/indexRotas";
import PaginaMapaIndependente2 from "../Layouts/indexMapas2";
import ConfiguracaoGeral from "../pages/ConfiguracaoGeral";
import Dashboard from "../pages/Dashboard";
import ListaLogs from "../pages/Logs";
import CadastroEspaco from "../pages/Espacos/Cadastro";
import ListaEspaco from "../pages/Espacos/Lista/index";
import ListaSenhas from "../pages/Senha/index";
import ListaEspacoRota from "../pages/EspacosRota/Lista/index";
import CadastroEspacoRota from "../pages/EspacosRota/Cadastro";
import MapaInterno from "../pages/Mapa/MapaInterno";

const authProtectedRoutes = [
  { path: "/configuracao-geral", component: <ConfiguracaoGeral />, roles: ["JOTAPIX", "EVOMAP"] },

  { path: "/formas-pagamento", component: <ListaFormaPagamento />, roles: ["JOTAPIX", "EVOMAP"] },
  { path: "/condicao-pagamento", component: <ListaCondicaoPagamento />, roles: ["JOTAPIX", "EVOMAP"] },
  { path: "/tipo-espaco", component: <ListaTipoEspaco />, roles: ["JOTAPIX", "EVOMAP"] },
  { path: "/tags", component: <ListaTags />, roles: ["JOTAPIX", "EVOMAP"] },
  { path: "/status-reserva", component: <ListaStatusReserva />, roles: ["JOTAPIX", "EVOMAP"] },
  { path: "/usuarios", component: <ListaUsuarios />, roles: ["JOTAPIX", "EVOMAP"] },
  { path: "/reservas", component: <ListaReservas gerouVenda={false}/>, roles: ["JOTAPIX", "EVOMAP", "COMERCIAL", "ORGANIZACAO"] },
  { path: "/senhas", component: <ListaSenhas/>, roles: ["JOTAPIX", "EVOMAP", "COMERCIAL", "ORGANIZACAO"] },
  { path: "/detalhe-reserva/:id", component: <ReservaDetalhes gerouVenda={false}/>, roles: ["JOTAPIX", "EVOMAP", "COMERCIAL", "ORGANIZACAO"] },
  { path: "/vendas", component: <ListaReservas gerouVenda={true}/>, roles: ["JOTAPIX", "EVOMAP", "COMERCIAL", "ORGANIZACAO"] },
  { path: "/detalhe-venda/:id", component: <ReservaDetalhes gerouVenda={true}/>, roles: ["JOTAPIX", "EVOMAP", "COMERCIAL", "ORGANIZACAO"] },
  { path: "/lista-espera", component: <ListaEspera/>, roles: ["JOTAPIX", "EVOMAP", "ORGANIZACAO"] },
  { path: "/lista-espacos", component: <ListaEspaco/> },
  { path: "/lista-espacos-rota", component: <ListaEspacoRota/> , roles: ["JOTAPIX", "EVOMAP", "ORGANIZACAO"] },
  { path: "/logs", component: <ListaLogs/>, roles: ["JOTAPIX", "EVOMAP", "ORGANIZACAO"] },
  { path: "/mapa-vendas", component: <MapaInterno/>, roles: ["JOTAPIX", "EVOMAP", "COMERCIAL", "ORGANIZACAO"] },
  { path: "/mapa-renovacao", component: <MapaInterno/>, roles: ["JOTAPIX", "EVOMAP", "COMERCIAL", "ORGANIZACAO"] },
  
  //Feiras
  { path: "/feiras-lista", component: <ListaFeira />, roles: ["JOTAPIX", "EVOMAP"] },
  { path: "/feira-cadastro", component: <CadastroFeira />, roles: ["JOTAPIX", "EVOMAP"] },
  { path: "/feira-cadastro/:id", component: <CadastroFeira />, roles: ["JOTAPIX", "EVOMAP"] },
  { path: "/espaco/novo/:feiraId", component: <CadastroEspaco/>},
  { path: "/espaco/:espacoId/:feiraId", component: <CadastroEspaco/>},
  //Feiras-Rota
  { path: "/espaco-rota/novo/:feiraId", component: <CadastroEspacoRota/>},
  { path: "/espaco-rota/:espacoId/:feiraId", component: <CadastroEspacoRota/>},

  //Expositores
  { path: "/expositor-lista", component: <ListaExpositor />, roles: ["JOTAPIX", "EVOMAP"] },
  { path: "/expositor-cadastro", component: <CadastroExpositor />, roles: ["JOTAPIX", "EVOMAP"] },
  { path: "/expositor-cadastro/:id", component: <CadastroExpositor />, roles: ["JOTAPIX", "EVOMAP"] },
  { path: "/expositor-importar", component: <ImportExpositoresModal/>, roles: ["JOTAPIX", "EVOMAP"]},
  
  { path: "/dashboard", component: <Dashboard/>},
  
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  
  { path: "/:nomeFeira/vendas/:idFeira", component: <PaginaMapaIndependente /> },
  { path: "/:nomeFeira/renovacao/:idFeira", component: <PaginaMapaIndependente2 /> },
  { path: "/:nomeFeira/rotas/:idFeira", component: <MapaComRota /> },

  { path: "/mapa-desativado", component: <MapaDesativado/> },
  { path: "/nao-encontrada", component: <NaoEncontrada/> },

  { path: "/vendas/:idFeira", component: <PaginaMapaIndependente /> },
  { path: "/renovacao/:idFeira", component: <PaginaMapaIndependente2 /> },
  { path: "/rotas/:idFeira", component: <MapaComRota /> },

];

export { authProtectedRoutes, publicRoutes };
